export enum BaseParameterTypes {
  HOOKLOAD = 'HOOKLOAD',
  STANDPIPE_PRESSURE = 'STANDPIPE_PRESSURE',
  DEPTH_HOLE = 'DEPTH_HOLE',
  ROTARY_TORQUE = 'ROTARY_TORQUE',
  BLOCK_POSITION = 'BLOCK_POSITION',
  DEPTH_BIT = 'DEPTH_BIT',
  MUD_FLOW_IN = 'MUD_FLOW_IN',
  RATE_OF_PENETRATION = 'RATE_OF_PENETRATION',
  WEIGHT_ON_BIT = 'WEIGHT_ON_BIT',
  ROTARY_SPEED = 'ROTARY_SPEED',
  AUTO_RECOGNIZED_EVENTS = 'AUTO_RECOGNIZED_EVENTS',
  AUTO_RECOGNIZED_OPERATIONS = 'AUTO_RECOGNIZED_OPERATIONS',
  MAGNETIC_TOOLFACE = 'MAGNETIC_TOOLFACE',
  GRAVITY_TOOLFACE = 'GRAVITY_TOOLFACE',
  BIT_SPEED = 'BIT_SPEED',
  BIT_CONTACT_PRESSURE = 'BIT_CONTACT_PRESSURE',
  MECH_SPEC_ENERGY_BIT = 'MECH_SPEC_ENERGY_BIT',
  MECH_SPEC_ENERGY_SURFACE = 'MECH_SPEC_ENERGY_SURFACE',
}

export const timeSortedParametersNoAutoRecognized = [
  BaseParameterTypes.DEPTH_HOLE,
  BaseParameterTypes.DEPTH_BIT,
  BaseParameterTypes.BLOCK_POSITION,
  BaseParameterTypes.HOOKLOAD,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.ROTARY_SPEED,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.MAGNETIC_TOOLFACE,
  BaseParameterTypes.GRAVITY_TOOLFACE,
] as const;

export const timeSortedParameters = [
  BaseParameterTypes.AUTO_RECOGNIZED_EVENTS,
  BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS,
  ...timeSortedParametersNoAutoRecognized,
] as const;

export const depthSortedParameters = [
  BaseParameterTypes.BLOCK_POSITION,
  BaseParameterTypes.HOOKLOAD,
  BaseParameterTypes.WEIGHT_ON_BIT,
  BaseParameterTypes.BIT_CONTACT_PRESSURE,
  BaseParameterTypes.ROTARY_SPEED,
  BaseParameterTypes.BIT_SPEED,
  BaseParameterTypes.ROTARY_TORQUE,
  BaseParameterTypes.MUD_FLOW_IN,
  BaseParameterTypes.STANDPIPE_PRESSURE,
  BaseParameterTypes.RATE_OF_PENETRATION,
  BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE,
  BaseParameterTypes.MECH_SPEC_ENERGY_BIT,
  BaseParameterTypes.MAGNETIC_TOOLFACE,
  BaseParameterTypes.GRAVITY_TOOLFACE,
] as const;

export const nameDictionary: Record<BaseParameterTypes, string> = {
  [BaseParameterTypes.DEPTH_HOLE]: 'holeDepth',
  [BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS]: 'operation',
  [BaseParameterTypes.DEPTH_BIT]: 'bitDepth',
  [BaseParameterTypes.AUTO_RECOGNIZED_EVENTS]: 'event',
  [BaseParameterTypes.HOOKLOAD]: 'hookload',
  [BaseParameterTypes.STANDPIPE_PRESSURE]: 'standpipePressure',
  [BaseParameterTypes.ROTARY_TORQUE]: 'rotaryTorque',
  [BaseParameterTypes.BLOCK_POSITION]: 'blockPosition',
  [BaseParameterTypes.MUD_FLOW_IN]: 'mudFlowIn',
  [BaseParameterTypes.ROTARY_SPEED]: 'rotarySpeed',
  [BaseParameterTypes.WEIGHT_ON_BIT]: 'weightOnBit',
  [BaseParameterTypes.RATE_OF_PENETRATION]: 'penetrationRate',
  [BaseParameterTypes.GRAVITY_TOOLFACE]: 'gravityToolface',
  [BaseParameterTypes.MAGNETIC_TOOLFACE]: 'magneticToolface',
  [BaseParameterTypes.BIT_CONTACT_PRESSURE]: 'bitContactPressure',
  [BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE]: 'mechSpecEnergySurface',
  [BaseParameterTypes.MECH_SPEC_ENERGY_BIT]: 'mechSpecEnergyBit',
  [BaseParameterTypes.BIT_SPEED]: 'bitSpeed',
};

export const baseParamsToMnemonic: Record<BaseParameterTypes, string> = {
  [BaseParameterTypes.HOOKLOAD]: 'HKLA',
  [BaseParameterTypes.STANDPIPE_PRESSURE]: 'SPPA',
  [BaseParameterTypes.DEPTH_HOLE]: 'DMEA',
  [BaseParameterTypes.ROTARY_TORQUE]: 'TQA',
  [BaseParameterTypes.BLOCK_POSITION]: 'BPOS',
  [BaseParameterTypes.DEPTH_BIT]: 'DBTM',
  [BaseParameterTypes.MUD_FLOW_IN]: 'MFI',
  [BaseParameterTypes.RATE_OF_PENETRATION]: 'ROP',
  [BaseParameterTypes.WEIGHT_ON_BIT]: 'WOB',
  [BaseParameterTypes.ROTARY_SPEED]: 'RPM',
  [BaseParameterTypes.AUTO_RECOGNIZED_EVENTS]: 'OP',
  [BaseParameterTypes.AUTO_RECOGNIZED_OPERATIONS]: 'KPI',
  [BaseParameterTypes.MAGNETIC_TOOLFACE]: 'SMTF',
  [BaseParameterTypes.GRAVITY_TOOLFACE]: 'SGTF',
  [BaseParameterTypes.BIT_CONTACT_PRESSURE]: 'DBHP',
  [BaseParameterTypes.MECH_SPEC_ENERGY_SURFACE]: 'SMSE',
  [BaseParameterTypes.MECH_SPEC_ENERGY_BIT]: 'DMSE',
  [BaseParameterTypes.BIT_SPEED]: 'BIT_RPM',
};
